import { extend } from 'lodash-es'
import { pad, unpad } from './string.ts'
import { YEAR_ONLY_CUTOFF_YEAR } from '@constants/date.js'
import { defaultEditableDate } from '@helpers/date_helpers.js'

// An editable date is a basic JavaScript object with properties that can be edited individually
// Note: We don't use a class for this, as it's not recommended to store in Redux due to not being able to be serialized

// splits a string into an object with key/value representations for each individual part (year, month, day, etc)
export function editableDateRecordFromString(value) {
  let year = ''
  let month = ''
  let day = ''
  let isBCE = false

  if (value && value.length > 0) {
    isBCE = value.charAt(0) === '-'
    const matchResult = value.match(/-/g)
    const numHyphens = matchResult === null ? 0 : matchResult.length
    if (numHyphens > 1) {
      // we have days, months etc. If is bc date, then remove the leading minus sign before splitting the date string
      const vals = isBCE ? value.substring(1, value.length - 1).split('-') : value.split('-')
      year = vals[0] === 'undefined' ? '' : vals[0]
      month = parseInt(unpad(vals[1])).toString()
      day = unpad(vals[2].split(' ')[0])
    } else {
      // we just have a year
      year = isBCE ? value.substring(1, value.length) : value
      month = ''
      day = ''
    }

    // adjust year value to be human-friendly (basically convert to the era year by adding 1 year)
    if (isBCE) {
      let eraYear = parseInt(year) + 1
      year = eraYear.toString()
    }

    return extend({}, defaultEditableDate(), {
      day,
      month,
      year,
      isBCE,
    })
  } else {
    return defaultEditableDate()
  }
}

// converts an object of key/values representating a date into a string that can be consumed by the backend api
export function editableDateRecordToString(record) {
  let returnVal = null
  if (record.year) {
    let yearInt = parseInt(record.year)
    if (record.isBCE) {
      // adjust from an era year to a 0 equals 1 BCE year
      yearInt = Math.abs(yearInt) - 1
    } else if (yearInt < 1) {
      // Note: Record may not be marked explicitly as BCE, but the year may be filled in as negative by the user
      yearInt = Math.abs(yearInt) - 1
      record.isBCE = true
    }
    let year = record.isBCE && yearInt >= 1 ? -yearInt : yearInt
    let { month, day } = record
    if (year === '' || year === '-') {
      year = null
    }
    const missingMonth = !month || month === ''
    const missingDay = !day || day === ''
    const missingMonthOrDay = missingMonth || missingDay

    if (record.isBCE || year < YEAR_ONLY_CUTOFF_YEAR || missingMonthOrDay) {
      // just return the year
      returnVal = `${year}`
    } else {
      returnVal = `${year}-${pad(month)}-${pad(day)} 00:00:00`
    }
  } else {
    // year isn't even valid
    returnVal = null
  }
  return returnVal
}
